export enum UsageTypes {
  Industrial = 'Industrial',
  Office = 'Office',
  Retail = 'Retail',
}
